import httpClient from './httpClient';

export const AUDIT_LOG_ENDPOINT = '/backoffice/audit-logs';

export const getAuditLogsAPI = (params = {}) => httpClient.get(AUDIT_LOG_ENDPOINT, { params });
export const getAuditLogAPI = (id) => httpClient.get(`${AUDIT_LOG_ENDPOINT}/${id}`);
export const getAuditLogOptionAPI = () => httpClient.get(`${AUDIT_LOG_ENDPOINT}/filters`);
